import { keepPreviousData } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { DashboardCarRatingRowDisplay } from './use-dashboard-performance';

export type CarRating = DashboardCarRatingRowDisplay & {
  id: number;
  name: string;
  averageScore: number | null;
  pickupAndReturnRating: number | null;
  carConditionRating: number | null;
  cleanlinessRating: number | null;
  reviewCount: number;
};

export type CarRatingsSummary = {
  totalCars: number;
  ratedTrips: number;
};

export type CarRatingsResponse = {
  data: CarRating[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
  summary: CarRatingsSummary;
};

type Variables = {
  from: string;
  to: string;
  page?: number;
  perPage?: number;
};

export const useCarRatings = createQuery<
  CarRatingsResponse,
  Variables,
  AxiosError
>({
  queryKey: ['dashboard/car-ratings'],
  placeholderData: keepPreviousData,
  fetcher: (variables) => {
    return client
      .get('v2/internal/partners/dashboard/car-ratings', {
        params: {
          from: variables.from,
          to: variables.to,
          page: variables.page ?? 1,
          per_page: variables.perPage ?? 50,
        },
      })
      .then((response) => response.data as CarRatingsResponse);
  },
});
